import { Checkbox, getSpacing, Stack, Typography } from "@compass/core";
import { AprSection as AprSectionModel } from "generated/openApi";
import "moment-timezone";

export const AprSection = (props: {
  section: AprSectionModel;
  selectedSectionItemIds: number[];
  setSelectedSectionItemIds: (value: number[]) => void;
}) => {
  const allSelected = props.selectedSectionItemIds.length === props.section.items?.length;
  const someSelected = props.selectedSectionItemIds.length > 0 && !allSelected;

  return (
    <Stack spacing="xs">
      <Checkbox
        label={
          <Typography fontSize="1.15rem" fontWeight={(theme) => theme.typography.fontWeightRegular}>
            {props.section.name}
          </Typography>
        }
        checked={allSelected}
        indeterminate={someSelected}
        onChange={() => {
          if (allSelected) props.setSelectedSectionItemIds([]);
          else props.setSelectedSectionItemIds(props.section.items?.map((x) => x.id) || []);
        }}
      />

      <Stack pl={getSpacing("md")}>
        {props.section.items?.map((item) => {
          const selected = props.selectedSectionItemIds.includes(item.id);

          return (
            <Checkbox
              label={item.name}
              checked={selected}
              onChange={() => {
                if (selected)
                  props.setSelectedSectionItemIds(props.selectedSectionItemIds.filter((x) => x !== item.id));
                else props.setSelectedSectionItemIds([...props.selectedSectionItemIds, item.id]);
              }}
            />
          );
        })}
      </Stack>
    </Stack>
  );
};
